import 'css-chunksrc/client/pages/projectPage/budgetPage/exportButton/styles.scss';export default {
  "exportButton": "_exportButton_iyz7b_1",
  "text": "_text_iyz7b_17",
  "icon": "_icon_iyz7b_21"
};